const OPENPAY_MERCHANT_ID = process.env.REACT_APP_OPENPAY_COMMERCE_ID || '';
const OPENPAY_PUBLIC_KEY = process.env.REACT_APP_OPENPAY_PUBLIC_KEY || '';
const OPENPAY_SANDBOX = (
  String(process.env.REACT_APP_OPENPAY_SANDBOX || '').trim().toLowerCase() === 'true'
);

let openpayPromise = null;

const loadScript = (src) => new Promise((resolve, reject) => {
  const existing = document.querySelector(`script[src="${src}"]`);
  if (existing) {
    if (existing.dataset.loaded || existing.readyState === 'complete') {
      resolve();
      return;
    }
    existing.addEventListener('load', resolve, { once: true });
    existing.addEventListener('error', reject, { once: true });
    return;
  }

  const script = document.createElement('script');
  script.src = src;
  script.onload = () => {
    script.dataset.loaded = '1';
    resolve();
  };
  script.onerror = reject;
  document.head.appendChild(script);
});

export const loadOpenPay = () => {
  if (openpayPromise) return openpayPromise;

  openpayPromise = (async () => {
    await loadScript('https://js.openpay.mx/openpay.v1.min.js');
    const openpay = window.OpenPay;
    if (!openpay) throw new Error('No se pudo cargar Openpay.');
    if (!OPENPAY_MERCHANT_ID || !OPENPAY_PUBLIC_KEY) {
      throw new Error('Faltan las credenciales públicas de Openpay.');
    }

    openpay.setId(OPENPAY_MERCHANT_ID);
    openpay.setApiKey(OPENPAY_PUBLIC_KEY);
    openpay.setSandboxMode(OPENPAY_SANDBOX);
    await loadScript('https://js.openpay.mx/openpay-data.v1.min.js');
    return openpay;
  })();

  return openpayPromise;
};

export const setupOpenPayDeviceSession = async (formId, fieldName) => {
  const openpay = await loadOpenPay();
  return openpay.deviceData.setup(formId, fieldName) || '';
};

export const createOpenPayCardToken = async (card) => {
  const openpay = await loadOpenPay();
  const cleanCardNumber = card.cardNumber.replace(/\D/g, '');

  if (!openpay.card.validateCardNumber(cleanCardNumber)) {
    throw new Error('El número de tarjeta no es válido.');
  }
  if (!openpay.card.validateExpiry(card.expirationMonth, card.expirationYear)) {
    throw new Error('La fecha de vencimiento no es válida.');
  }
  if (!openpay.card.validateCVC(card.cvv2, cleanCardNumber)) {
    throw new Error('El código de seguridad no es válido.');
  }

  return new Promise((resolve, reject) => {
    openpay.token.create(
      {
        holder_name: card.holderName.trim(),
        card_number: cleanCardNumber,
        expiration_month: card.expirationMonth,
        expiration_year: card.expirationYear,
        cvv2: card.cvv2,
      },
      (response) => resolve(response.data.id),
      (response) => reject(new Error(
        response.data?.description || 'Openpay no pudo tokenizar la tarjeta.'
      ))
    );
  });
};
